import "./chatloader.css";

const ChatLoader = () => {
  return (
    <div className="loader-background">
      <div className="loaderWrapper">
        <div className="customLoader"></div>
      </div>
    </div>
  );
};

export default ChatLoader;
